function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
var _excluded = ["message", "variant", "onClose", "sx"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { Snackbar } from '@mui/material';
import { ToastContainer, CloseIcon } from './styles/ToastStyled';
import { colors } from '../../@theme/colors';
import { SuccessIcon, ErrorIcon, InfoIcon, AlertIcon, CrossIcon } from '../../@theme/assets/svg/icons/toast';
var toastVariants = {
  success: {
    color: colors.NotificacionesVerde,
    background: colors.NotificacionBackgroundVerde,
    icon: React.createElement(SuccessIcon, null),
    iconColor: colors.NotificacionesVerdeHover
  },
  alert: {
    color: colors.NotificacionesAmarillo,
    background: colors.NotificacionBackgroundAmarillo,
    icon: React.createElement(AlertIcon, null),
    iconColor: colors.NotificacionesAmarilloHover
  },
  error: {
    color: colors.NotificacionesRojo,
    background: colors.NotificacionBackgroundRojo,
    icon: React.createElement(ErrorIcon, null),
    iconColor: colors.NotificacionesRojo
  },
  info: {
    color: colors.Neutros60,
    background: colors.NeutrosDeshabilitado,
    icon: React.createElement(InfoIcon, null),
    iconColor: colors.Neutros60
  }
};
var Toast = function Toast(_ref) {
  var message = _ref.message,
    variant = _ref.variant,
    onClose = _ref.onClose,
    sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var _toastVariants$varian = toastVariants[variant],
    color = _toastVariants$varian.color,
    icon = _toastVariants$varian.icon,
    background = _toastVariants$varian.background,
    iconColor = _toastVariants$varian.iconColor;
  var action = React.createElement(CloseIcon, {
    iconColor: iconColor
  }, React.createElement(CrossIcon, {
    onClick: onClose
  }));
  var toastMessage = React.createElement(ToastContainer, {
    color: color,
    variant: background,
    iconColor: iconColor
  }, React.createElement("div", null, icon), React.createElement("span", null, message));
  var sxConf = _objectSpread({
    '.MuiSnackbarContent-root': {
      borderRadius: '8px',
      border: " 2px solid ".concat(color),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: '42px',
      alignItems: 'center',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '18px',
      paddingLeft: '0',
      paddingTop: '0',
      paddingBottom: '0',
      background: background,
      color: colors.Neutros60
    },
    '.MuiSnackbarContent-message': {
      padding: '0',
      height: '100%'
    }
  }, sx);
  return React.createElement(Snackbar, _extends({
    message: toastMessage,
    action: action,
    onClose: onClose,
    autoHideDuration: 6000,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    sx: sxConf
  }, props));
};
export default Toast;